import { TNil } from '@app/app.interface';
import { EAnalyticsStatus } from '@enums/campaign-analytics.enum';
import { IManualDeliverableStatus } from '@interfaces/campaign-analytics-api.interface';
import { IDeliverableCard } from '../cta-analytics-details-deliverable-card.interface';

export enum EManualDeliverableStatusAction {
  accept = EAnalyticsStatus.ok,
  reject = EAnalyticsStatus.failed,
  remove = 0,
}

export interface IManualDeliverableStatusConfig {
  manualDeliverableStatus: IManualDeliverableStatus | TNil;
  deliverableCard: IDeliverableCard;
  actionsVisible: boolean;
  statusVisible: boolean;
  analyticsVisible: boolean;
  creatorBriefingMode: boolean;
  exportMode: boolean;
  /** The active campaign export's id when exportMode is true - used to call the export-scoped findings endpoint. */
  campaignExportId: string | null;
}
